import { createElement, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { useButton } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import buttonStyles from '../Button.module.scss';
import iconButtonStyles from '../IconButton.module.scss';
// https://react-spectrum.adobe.com/react-aria/useButton.html

// eslint-disable-next-line react/display-name
const Standard = forwardRef((
    { children, variant, className, elementType, triggerRef, isDisabled, icon, role, ...props },
    ref
) => {
    const styles = icon ? iconButtonStyles : buttonStyles;
    const defaultRef = useRef();
    const buttonRef = ref || defaultRef;
    const isUnstyled = variant === 'unstyled';

    const { buttonProps, isPressed } = useButton({
        ...props,
        elementType,
        isDisabled
    }, buttonRef);

    return createElement(elementType, {
        'data-testid': props['data-testid'],
        ref: buttonRef,
        title: props.title,
        className: [
            isUnstyled ? null : 'govuk-button',
            isUnstyled ? styles.unstyled : styles[variant],
            className,
            isPressed ? styles.pressed : null,
            isDisabled ? styles.disabled : null
        ].join(' '),
        ...buttonProps,
        role: role ?? buttonProps.role
    }, children);
});

Standard.propTypes = {
    ...defaultAriaProps,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'warning', 'success', 'info', 'transparent', 'link', 'unstyled']),
    elementType: PropTypes.oneOf(['button', 'span', 'div']),
    triggerRef: PropTypes.any,
    isDisabled: PropTypes.bool,
    icon: PropTypes.bool
};

Standard.defaultProps = {
    variant: 'default',
    elementType: 'span'
};

export default Standard;
